import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1826e3fc")

_pushScopeId("data-v-1826e3fc")
const _hoisted_1 = { class: "FTLBidsList" }
const _hoisted_2 = { class: "FTLBidsList__header" }
const _hoisted_3 = { class: "header__left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Скачать в Excel ")
const _hoisted_6 = { class: "FTLBidsList__list scroll green" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"list__header\" data-v-1826e3fc><div class=\"list__row header\" data-v-1826e3fc><div class=\"list__col first header\" data-v-1826e3fc>ID</div><div class=\"list__col second header\" data-v-1826e3fc>Номер заказа клиента</div><div class=\"list__col second header\" data-v-1826e3fc>Тип</div><div class=\"list__col second header\" data-v-1826e3fc>Направление</div><div class=\"list__col third header\" data-v-1826e3fc>Статус</div><div class=\"list__col fourth header\" data-v-1826e3fc>Дата забора</div><div class=\"list__col fifth header\" data-v-1826e3fc>Время забора</div><div class=\"list__col sixth header\" data-v-1826e3fc></div></div></div>", 1)
const _hoisted_8 = { class: "list__body" }
const _hoisted_9 = { class: "list__col first col-big" }
const _hoisted_10 = { class: "list__col second" }
const _hoisted_11 = { class: "list__col second" }
const _hoisted_12 = { class: "list__col second" }
const _hoisted_13 = { class: "list__col third" }
const _hoisted_14 = { class: "list__col fourth" }
const _hoisted_15 = { class: "list__col fifth" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Подробнее ")
const _hoisted_17 = {
  key: 1,
  class: "list__row empty"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "list__col full" }, "Нет заявок", -1)
const _hoisted_19 = {
  key: 1,
  class: "FTLBidsList__loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_ctx.withRefresh)
          ? (_openBlock(), _createBlock(_component_icon_refresh, {
              key: 0,
              class: "header__refresh",
              onClick: _ctx.emitRefresh
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_s_button, {
        class: "primary",
        onClick: _ctx.emitExcel
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              (_ctx.bids && _ctx.bids.length > 0)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.bids, (bid, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "list__row",
                      key: `FTLBidsList-bid-${i}`
                    }, [
                      _createVNode("div", _hoisted_9, _toDisplayString(bid.id || '-'), 1),
                      _createVNode("div", _hoisted_10, _toDisplayString(bid.dop_order_number || '-'), 1),
                      _createVNode("div", _hoisted_11, _toDisplayString(bid.ftl_type_name || '-'), 1),
                      _createVNode("div", _hoisted_12, _toDisplayString(bid.direction || '-'), 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(bid.status_name || '-'), 1),
                      _createVNode("div", _hoisted_14, _toDisplayString(bid.take_date || '-'), 1),
                      _createVNode("div", _hoisted_15, _toDisplayString(bid.take_time || '-'), 1),
                      _createVNode(_component_router_link, {
                        to: `/ftl/bid/${bid.id}`,
                        class: "list__col sixth col-shadow"
                      }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock("div", _hoisted_17, [
                    _hoisted_18
                  ]))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode(_component_s_loader)
        ]))
  ]))
})